// removed by extract-text-webpack-plugin
module.exports = {"Favorites":"Favorites__Favorites__-hash-base-64-5-","ClearButton":"Favorites__ClearButton__-hash-base-64-5-"};


//////////////////
// WEBPACK FOOTER
// ./src/components/containers/Favorites/Favorites.scss
// module id = 196
// module chunks = 0